import React from 'react'
import Link from 'next/link'
import Image from 'next/image';
import SectionHeading from '../../Common/SectionHeading';


const items = Array(4).fill(null);
export default function JourneySection({ data = null }) {
    return (
        <>
            {(data) &&
                <>
                    <section className="bg-gradient-to-tr from-blue-600 to-blue-200">
                        <div className="w-11/12 xl:max-w-screen max-w-screen-2xl flex flex-col justify-center mx-auto md:py-14 py-8">
                            <SectionHeading
                                title="Journey with us"
                                customClass="text-center text-white"
                                headClass="before:bg-[#fff]"
                            />
                            <div className="grid grid-cols-12 md:py-6">
                                {data?.map((item, index) => (
                                    <div key={index} className="md:col-span-3 col-span-6">
                                        <div className={index % 2 != 0 ? 'md:top-8 md:mt-0 mt-5 md:mb-0 mb-5 text-center mx-auto relative' : 'md:bottom-8 md:mt-0 mt-5 md:mb-0 mb-5 text-center mx-auto relative'}>
                                            <div className={index == 1 ? 'absolute md:right-[-53px] top-0 m-5 md:rotate-180 md:-scale-x-100 md:block hidden' : index === 3 ? 'hidden' : 'absolute md:right-[-53px] top-0 md:block hidden'}>
                                                <Image priority={false}
                                                    width={2000}
                                                    height={2000}
                                                    src={process.env.IMG_CDN+item?.iconImageSrc}
                                                    alt={item?.altText ? item?.altText : item?.title ? item?.title : 'DelveInsight'}
                                                    className="md:w-28 w-20 md:h-28 h-20"
                                                />
                                            </div>
                                            <div>
                                                <div className="flex justify-center items-center relative text-center w-[130px] h-[130px] line-[130px] shadow-lg bg-white rounded-full mx-auto">
                                                    <Image priority={false}
                                                        width={2000}
                                                        height={2000}
                                                        src={process.env.IMG_CDN+item?.imageSrc}
                                                        alt={item?.altText ? item?.altText : item?.title ? item?.title : 'DelveInsight'}
                                                        className="w-20 h-20"
                                                    />
                                                </div>
                                                <h3 className="text-lg font-semibold text-white">
                                                    {item?.title}
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>
                </>
            }
        </>
    )
}
